import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const UnifiedLoginModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Login_Unificado" data-name="Login Unificado">
          <g>
            <path
              fill={fillColor200}
              opacity="0.25"
              d="M294.57,179c-91.46,68.89-256.95,342.1-199.69,449,75,140,250.57,52.31,372,41C982.32,620.93,640.11-81.23,294.57,179Z"
            />
            <g opacity="0.2">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M304.43,185.8c-19.35-30.14-54.1-48.94-92.34-45.53-51.08,4.56-90.65,48.41-90.45,100.27v1a97.21,97.21,0,0,1-9.07,41.74A60.49,60.49,0,0,0,107.35,314c2.88,32.28,31.06,56.71,63,54.73,12.39-.77,38.3-12.41,58-21.71,13.29-6.27,24.94-7.76,37.57-.21,14.36,8.59,44.49,7.46,60.1-7.37,29.29-27.83,28.77-39.31,29.22-80.16.2-18.33,7.71-40.73-27-48.62C318.84,208.51,309.69,194,304.43,185.8Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M495.27,695.66c26.71,21.43,65,28.08,100.62,13.68,47.53-19.23,73.34-70.47,59-117.14-.1-.31-.19-.62-.29-.94A87.22,87.22,0,0,1,651.86,551a54.28,54.28,0,0,0-3.4-29.19c-11.56-28.23-45.15-41.9-75.15-30.64-11.62,4.36-33.18,22.53-49.45,36.74-11,9.58-21.7,14.38-35.82,11.31-16.06-3.49-44.53,6.46-55.38,24.45-20.37,33.74-16.74,43.94-6,80.88,4.82,16.57,3.76,39,39.08,35.8C475.31,679.46,488,689.84,495.27,695.66Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M84.25,411.21C54.41,431,36.12,466,40.1,504.22c5.32,51,49.76,89.92,101.61,88.95l1,0a97.23,97.23,0,0,1,41.87,8.45,60.55,60.55,0,0,0,30.75,4.77c32.23-3.36,56.24-31.91,53.78-63.85-.95-12.38-13-38.12-22.57-57.67-6.46-13.19-8.13-24.82-.77-37.56,8.38-14.48,6.8-44.6-8.27-60-28.26-28.86-39.73-28.18-80.59-28-18.32.07-40.83-7.11-48.2,27.73C106.75,396.47,92.36,405.84,84.25,411.21Z"
              />
            </g>
            <path
              fill={fillColor600}
              d="M782.1,317.45a29.92,29.92,0,0,0-7.23-35.23c-10.26-9.15-23.18-20.77-26.88-20.9-17.19-.57-4.31,70.36,3.74,79.06C760.88,350.27,774.15,334,782.1,317.45Z"
            />
            <path
              fill={fillColor600}
              d="M26.07,616.73c-1.6,15.59,23.47,31.71,32.43,22.76,9-10.75-9-30.45-19.36-42.41C32.47,594.44,27.51,605.54,26.07,616.73Z"
            />
            <path
              fill={fillColor600}
              d="M284.73,146.72c-15.35,6.18-35.75-8.57-41.94-23.92s4.2-25.49,19.55-31.68,46.85-4.4,53,10.95S300.08,140.53,284.73,146.72Z"
            />
            <path
              fill={fillColor600}
              d="M62.59,348.75c-.27.56-.53,1.11-.8,1.66-3.16,6.21-38.1,82.79,100.54,182C307,636,400.22,694.67,468.11,685.33s167.11-96.22,184-161.77S691,337.67,621,269.33s-200.89-94-348.44-50.66C126.36,261.6,83.79,304.2,62.59,348.75Z"
            />
          </g>
          <g>
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M334.36,385.4,312,335.7a54.09,54.09,0,0,1,12.43-57.16l72.07-72.07c14.91-14.91,34.79-17.39,54.67-9.94l87,37.28a49.21,49.21,0,0,1,27.34,27.34l37.27,87c7.46,19.88,2.49,39.76-9.94,54.67l-72.07,72.07c-14.91,14.91-34.79,17.39-54.67,9.94l-52.19-22.37L264.78,611.55H185.25V532Z"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M456.13,325.76c-5,0-9.94,5-9.94,9.94s5,9.94,9.94,9.94,9.94-5,9.94-9.94-5-9.94-9.94-9.94"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(UnifiedLoginModuleBrand)
